module.exports = __webpack_public_path__ + "static/img/13.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/13.png
// module id = 3k2z
// module chunks = 0